import { takeLatest, put, call, all } from 'redux-saga/effects';
import {
    setZoomMasterList,
    setZoomSubAccountsList,
    setLoading,
    setSuccessCreation,
    setSuccessSynchronization,
    setSuccessSubAccountCreation,
    setCount,
    setErrorType,
    setLoadingCreation,
    setSuccessRemoveZoomProAccount,
    setSuccessRemoveZoomSubAccount,
    setSuccessAssignForUser
} from '@store/reducers/zoomReducer';
import { resourceService } from '@libs/axios';
import {
    fetchingZoomMasterList,
    createZoomMaster,
    createZoomSubAccount,
    fetchingZoomSubAccountsList,
    syncSubAccount,
    removeZoomProAccount,
    removeZoomSubAccount,
    FETCHING_ZOOM_MASTER_LIST,
    CREATE_ZOOM_MASTER,
    FETCHING_ZOOM_SUB_ACCOUNTS_LIST,
    CREATE_ZOOM_SUB_ACCOUNT,
    SYNC_SUB_ACCOUNT,
    REMOVE_ZOOM_PRO_ACCOUNT,
    REMOVE_ZOOM_SUB_ACCOUNT,
    assignForUser,
    ASSIGN_FOR_USER
} from '@store/actions/zoomActions';

import { ResponseType } from '@store/index';
import { toast } from 'react-toastify';
const API_URL = process.env.REACT_APP_API_URL;

// Map backend assignForUser error messages to Vietnamese for toast
const ASSIGN_FOR_USER_ERROR_MAP: Record<string, string> = {
  'Permissions denied': 'Bạn không có quyền thực hiện thao tác này',
  'zoom_account_id and auth_user are required': 'Vui lòng chọn tài khoản Zoom và người dùng cần gán',
  'Auth user not found': 'Không tìm thấy người dùng trong hệ thống',
  'Auth user already has a zoom account': 'Người dùng này đã được gán tài khoản Zoom, vui lòng bỏ gán tài khoản Zoom này trước khi gán tài khoản Zoom mới',
  'Zoom account not found': 'Không tìm thấy tài khoản Zoom',
  'Zoom account must be active': 'Tài khoản Zoom phải ở trạng thái hoạt động',
  'Zoom account must be a sub account': 'Chỉ được gán tài khoản Zoom loại sub (tài khoản phụ)',
};
function getAssignForUserErrorMessage(backendError: string | undefined): string {
  if (!backendError || typeof backendError !== 'string') return 'Gán tài khoản Zoom cho người dùng thất bại';
  const trimmed = backendError.trim();
  return ASSIGN_FOR_USER_ERROR_MAP[trimmed] ?? `Gán tài khoản Zoom thất bại: ${trimmed}`;
}

function* fetchingZoomMasterListSaga(action: ReturnType<typeof fetchingZoomMasterList>) {
  const { page, page_size, search_term } = action.payload;
  yield put(setLoading(true));
  try {
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + '/api/zoom_account_management/', {
      params: {
        page: page,
        page_size: page_size,
        search_term: search_term?.trim() || undefined,
      }
    }
    );

    if (response?.data) {
      yield put(setZoomMasterList(response.data.results));
      yield put(setCount(response.data.count));
      yield put(setLoading(false));
    }
  } catch (e: any) {
    yield put(setLoading(false));
    yield put(setCount(0));
    let error: Error = e;
    console.log(error);
  }
}
function* fetchingZoomSubAccountsListSaga (action: ReturnType<typeof fetchingZoomSubAccountsList>) {
  const {page, page_size,zoomMasterId } = action.payload;
  yield put(setLoading(true));
  try {
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + `/api/zoom_account_management/${zoomMasterId}/sub_accounts/`, {
      params: {
        page: page,
        page_size: page_size,
      }
    }
    );
    if (response?.data) {
      yield put(setZoomSubAccountsList(response.data));
      yield put(setLoading(false));
    }
  } catch (e: any) {
    yield put(setLoading(false));
    let error: Error = e;
    console.log(error);
  }
}

function* createZoomMasterSaga(action: ReturnType<typeof createZoomMaster>) {
  yield put(setSuccessCreation(false));
  yield put(setLoadingCreation(true));
  yield put(setErrorType(''));
  try {
    const response: ResponseType = yield call(resourceService.post, API_URL + '/api/create_zoom_master/', action.payload);
    if (response.status == 201) {
      toast.success('Tạo zoom master mới thành công');
      yield put(setSuccessCreation(true));
      yield put(setLoadingCreation(false));
    } else {
      yield put(setSuccessCreation(false));
      yield put(setLoadingCreation(false));
    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.detail || error?.message || 'An error occurred';
    console.log(errorMessage);

    // Parse error reason to extract field information and set error type
    let errorType = 'general_error';

    if (errorMessage.includes('Invalid client_id or client_secret')) {
      errorType = 'client_id_or_secret_invalid';
    } else if (errorMessage.includes('client_id')) {
      errorType = 'client_id_invalid';
    } else if (errorMessage.includes('client_secret')) {
      errorType = 'client_secret_invalid';
    } else if (errorMessage.includes('account_id')) {
      errorType = 'account_id_invalid';
    } else if (errorMessage.includes('token')) {
      errorType = 'token_invalid';
    } else if (errorMessage.includes('webhook')) {
      errorType = 'webhook_invalid';
    } else if (errorMessage.includes('verification')) {
      errorType = 'verification_invalid';
    }

    yield put(setErrorType(errorType));
    yield put(setSuccessCreation(false));
    yield put(setLoadingCreation(false));
  }
}
function* createSubAccountsSaga(action: ReturnType<typeof createZoomSubAccount>) {
  try {
    yield put(setLoading(true))
     yield put(setSuccessSubAccountCreation(false));
    const { zoomMasterId,email,firt_name,last_name } = action.payload;
    const data ={
      email: email.trim(),
      firt_name: firt_name.trim(),
      last_name: last_name.trim() 
    }
    const response: ResponseType = yield call(
      resourceService.post,
      API_URL + `/api/zoom_account_management/${zoomMasterId}/add_sub_account/`,
      data,
    );
    if (response.status === 201) {
      toast.success('Tạo tài khoản phụ thành công');
      yield put(setSuccessSubAccountCreation(true));
      yield put(setLoading(false));
      // const getZoomSubAccountsList: ResponseType = yield call(
      //   resourceService.get,
      //   API_URL + `/api/zoom_account_management/${zoomMasterId}/sub_accounts/`,
      // );
      //   if (getZoomSubAccountsList.status === 200) {
      //     yield put(setZoomSubAccountsList(getZoomSubAccountsList.data));
      //     yield put(setLoading(false))
      //   }
    }
  } catch (error: any) {
    console.error(error);
    toast.error("Thêm tài khoản phụ thất bại")
    yield put(setLoading(false))
    yield put(setSuccessSubAccountCreation(false));  

  }
}

function* syncSubAccounts(action: ReturnType<typeof syncSubAccount>) {
    const  zoomMasterId  = action.payload;
    yield put(setLoading(true));
    yield put(setSuccessSynchronization(false));
    try {
        const response: ResponseType = yield call(resourceService.get, 
              API_URL + `/api/zoom_account_management/${zoomMasterId}/async_account_zoom/`);
        if (response?.status === 200) {
          yield put(setSuccessSynchronization(true));
          toast.success('Đồng bộ thành công');
          // const getZoomSubAccountsList: ResponseType = yield call(
          //   resourceService.get,
          //   API_URL + `/api/zoom_account_management/${zoomMasterId}/sub_accounts/`,
          // );
          //   if (getZoomSubAccountsList.status === 200) {
          //     yield put(setZoomSubAccountsList(getZoomSubAccountsList.data));
          //     yield put(setLoading(false))
          //   }
          yield put(setLoading(false));
        }
    } catch (error: any) {
        yield put(setLoading(false));
        yield put(setSuccessSynchronization(false));
        console.log(error);
    }
}

function* removeZoomProAccountSaga(action: ReturnType<typeof removeZoomProAccount>) { 
  const zoomMasterId = action.payload;
  yield put(setLoading(true));
  yield put(setSuccessRemoveZoomProAccount(false)); // Set initial state to false
  try {
    const response: ResponseType = yield call(resourceService.delete, API_URL + `/api/zoom_account_management/${zoomMasterId}/delete_master_account/`);
    if (response?.status === 200) {
      yield put(setSuccessRemoveZoomProAccount(true));
      toast.success('Xóa tài khoản zoom master thành công');
      yield put(setLoading(false));
    }
  } catch (error: any) {
    toast.error('Xóa tài khoản zoom master thất bại: ' + error?.response?.data?.detail);
    yield put(setLoading(false));
    yield put(setSuccessRemoveZoomProAccount(false));
  }
}
function* removeZoomSubAccountSaga(action: ReturnType<typeof removeZoomSubAccount>) {
  const { zoomMasterId, zoomSubAccountEmail } = action.payload;
  yield put(setLoading(true));
  yield put(setSuccessRemoveZoomSubAccount(false));
  try {
    const response: ResponseType = yield call(resourceService.post, API_URL + `/api/zoom_account_management/${zoomMasterId}/delete_account_zoom/`, {
      email: zoomSubAccountEmail
    });
    if (response?.status === 200) {
      yield put(setSuccessRemoveZoomSubAccount(true));
      toast.success('Xóa tài khoản zoom sub account thành công');
      yield put(setLoading(false));
    }
  } catch (error: any) {
    toast.error('Xóa tài khoản zoom sub account thất bại: ' + error?.response?.data?.detail);
    yield put(setLoading(false));
    yield put(setSuccessRemoveZoomSubAccount(false));
    console.log(error);
  } 
}

function* assignForUserSaga(action: ReturnType<typeof assignForUser>) {
  const { zoomAccountId, authUserId, page, page_size, zoomMasterId } = action.payload;
  yield put(setLoading(true));
  yield put(setSuccessAssignForUser(false));
  try {
    const response: ResponseType = yield call(resourceService.post, API_URL + `/api/zoom_account_management/add_auth_user/`, {
      zoom_account_id: zoomAccountId,
      auth_user: authUserId
    });
    if (response?.status === 200) {
      console.log('response.data', response.data?.detail);
      const message = response.data?.detail?.includes('Update auth user for this zoom account successfully') ? 'Cập nhật người dùng gán cho tài khoản zoom sub account thành công' : 'Gán tài khoản zoom sub account cho người dùng thành công' ;
      yield put(setSuccessAssignForUser(true));
      toast.success(message);
      const getZoomSubAccountsList: ResponseType = yield call(
        resourceService.get,
        API_URL + `/api/zoom_account_management/${zoomMasterId}/sub_accounts/`,
        {
          params: {
            page: page,
            page_size: page_size
          }
        }
      );
      if (getZoomSubAccountsList.status === 200) {
        yield put(setZoomSubAccountsList(getZoomSubAccountsList.data));
        yield put(setLoading(false));
      }
    } else {
      yield put(setSuccessAssignForUser(false));
      yield put(setLoading(false));
      const errMsg = (response?.data?.error ?? response?.data?.detail) ?? '';
      toast.error(getAssignForUserErrorMessage(errMsg));
    }
  } catch (error: any) {
    yield put(setLoading(false));
    yield put(setSuccessAssignForUser(false));
    const errMsg = error?.response?.data?.error ?? error?.response?.data?.detail;
    toast.error(getAssignForUserErrorMessage(errMsg));
  } finally {
    yield put(setLoading(false));
  }
}

function* zoomSaga(): Generator<any, void, any> {
  yield takeLatest(FETCHING_ZOOM_MASTER_LIST, fetchingZoomMasterListSaga)
  yield takeLatest(FETCHING_ZOOM_SUB_ACCOUNTS_LIST, fetchingZoomSubAccountsListSaga)
  yield takeLatest(CREATE_ZOOM_MASTER, createZoomMasterSaga)
  yield takeLatest(CREATE_ZOOM_SUB_ACCOUNT, createSubAccountsSaga)
  yield takeLatest(SYNC_SUB_ACCOUNT, syncSubAccounts)
  yield takeLatest(REMOVE_ZOOM_PRO_ACCOUNT, removeZoomProAccountSaga)
  yield takeLatest(REMOVE_ZOOM_SUB_ACCOUNT, removeZoomSubAccountSaga)
  yield takeLatest(ASSIGN_FOR_USER, assignForUserSaga)
}

export default zoomSaga;